import type { ValidatedKey } from '@festina-life/core'

import { createRequiredAndOptionalContext } from '../../libs/context'

export type FormikChildListenerProviderContextType = {
  mountedFieldNames: string[]
  onFormikChildChange: ({
    action,
    name,
  }: {
    name: ValidatedKey
    action: 'add' | 'remove'
  }) => unknown
}

const [
  useFormikChildListenerContext,
  useOptionalFormikChildListenerContext,
  Provider,
] = createRequiredAndOptionalContext<FormikChildListenerProviderContextType>(
  'FormikChildListenerProviderContext',
)

export {
  Provider,
  useFormikChildListenerContext,
  useOptionalFormikChildListenerContext,
}
